import React, { useState, useEffect } from 'react';

import NavBar from './NavBar';
import UpdateCard from './UpdateCard';
import ProductCard from './ProductCard';
import WelcomeImage from './Welcome.png';
import DiraLogo from './diraIcon.svg';
import ponyTown from './ponyTown.png';
import etyCloud from './etyCloud.png';
import whitewhale from './whitewhale.png';

const HomePage = () => {
    const [language, setLanguage] = useState('en'); // Language state

    const toggleLanguage = () => {
        setLanguage(language === 'en' ? 'ru' : 'en');
    };


    useEffect(() => {
        const browserLanguage = navigator.language || navigator.userLanguage;

      
        if (browserLanguage.toLowerCase().includes('ru')) {
            setLanguage('ru');
        } else {
            setLanguage('en');
        }
    }, []);
    return (
        <div>
            <NavBar />
            <div className="content">
                {/* Language toggle button */}


                <h2>{language === 'en' ? 'Recent updates' : 'Последние обновления'}</h2>
                <div className="updates">


                    {language === 'en' ? (
                        <UpdateCard
                            title="We are a cloud provider now"
                            description="Whitewhale and etyCloud power our VPS and cloud services."
                            imgSrc={whitewhale}
                            link="https://whitewhale.help"
                        />
                    ) : (
                        <UpdateCard
                            title="Теперь мы облачный провайдер"
                            description="Whitewhale и etyCloud обеспечивают VPS и облачные сервисы."
                            link="https://whitewhale.help"
                            imgSrc={whitewhale}
                        />
                    )}

                    {language === 'en' ? (


                        <UpdateCard
                            title="Welcome to new eternity site!"
                            description="All eternity services in one place. New etyID platform to unite all of our services."
                            imgSrc={WelcomeImage}
                        />
                    ) : (
                        <UpdateCard
                            title="Добро пожаловать на новый сайт eternity!"
                            description="Все сервисы eternity в одном месте. Новая платформа etyID, объединяющая все наши сервисы."
                            imgSrc={WelcomeImage}
                        />
                    )}
                </div>

                <h2>{language === 'en' ? 'Products' : 'Продукты'}</h2>
                <div className="products">
                <ProductCard
                        title={language === 'en' ? 'etyCloud' : 'etyCloud'}
                        description={language === 'en' ? 'Cheap Europe hosting' : 'Дешёвый хостинг в Европе'}
                        imgSrc={etyCloud}
                        link="https://cloud.ety.one"
                    />
                    <ProductCard
                        title={language === 'en' ? 'Dira' : 'Dira'}
                        description={language === 'en' ? 'Independent messenger' : 'Независимый мессенджер'}
                        imgSrc={DiraLogo}
                        link="https://diranetwork.com"
                    />
                    <ProductCard
                        title={language === 'en' ? 'Whitewhale' : 'Whitewhale'}
                        description={language === 'en' ? 'Our Cloud Provider (VPS and more)' : 'Наш облачный провайдер (VPS и другое)'}
                        imgSrc={whitewhale}
                        link="https://whitewhale.help"
                    />
                    <ProductCard
                        title={language === 'en' ? 'Worlds of Pony' : 'Миры Пони'}
                        description={language === 'en' ? 'Fancy game with ponies' : 'Интересная игра с пони'}
                        imgSrc={ponyTown}
                        link="https://play.google.com/store/apps/details?id=ru.oig.ponyworldsonline"
                    />
                </div>

                <div className="footer">
                    <span className="footer-company">eternity cloud limited</span>
                    <button onClick={toggleLanguage}>
                        {language === 'en' ? 'Русский язык' : 'English language'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HomePage;
